module.exports = __webpack_public_path__ + "static/media/coding2.3b4ad5f9.png";